export const SettingsTranslationsDictionary =
{
    AppSettings: "App Settings",
    UserSettings: "User Settings",
    darkMode: "Dark Mode",
    largeFont: "Large Font",
    pictureInPicture: "Picture-in-Picture",
    checkForUpdates: "Check for Updates",
    sendFeedback: "Send feedback",
    softwareVersion: "Software version",
    driverProfile: "Driver Profile",
    changePassword: "Change Password",
    logout: "Logout",
    debugMode: "Debug Mode",
    reportAProblem: "Report a problem or request a feature",
    refreshAndSynchronizeData: "Refresh and Synchronize data",
    hoursOfService: "to display Hours of Service",
    DriverInformation: "Driver Information",
    CompanyInformation: "Company Information",
    currentDriver: "Current Driver",
    language: "Language",
    units: "Units",
    timezone: "Timezone",
    homeTerminal: "Home Terminal",
    companyName: "Company Name",
    databaseName: "Database Name",
    metric: "Metric units (kilometer, liter)",
    imperial: "Imperial units (mile, gallon)",
    languageChanged: "Language changed",
    languageChangeOffline: "You cannot change your language while offline.",
    moreLanguages: "More languages"
};

let getTranslations = () => {
    let r: string[] = [];
    for (const prop in SettingsTranslationsDictionary) {
        r.push(SettingsTranslationsDictionary[prop]);
    }
    return r;
};

export const SettingsTranslations = getTranslations();